module.exports = __webpack_public_path__ + "img/hs_ileti.512faccb.svg";